import React from 'react';

import BottomSlider from '../BottomSlider/BottomSlider';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

import './Modules.scss';
import Link from '../../../shared/Link/Link';

const ModuleBannerCarousel = ({
  slides,
  primaryColor,
  advertisingBannerVersion,
  isMobile,
}) => {
  const renderModuleBannerCarousel = () => {
    return isMobile
      ? renderModuleBannerCarouselMobile()
      : renderModuleBannerCarouselDesktop();
  };

  const renderModuleBannerCarouselDesktop = () => {
    return (
      <div className="hidden-mobile">
        <BottomSlider
          slides={slides}
          primaryColor={primaryColor}
          advertisingBannerVersion={advertisingBannerVersion}
        />
      </div>
    );
  };

  const renderModuleBannerCarouselMobile = () => {
    return (
      <div className="hidden-desktop">
        <div className="mobile-module-banner-carousel">
          {slides.map((slide, index) => {
            if (!!slide.link) {
              return (
                <Link
                  to={slide.link}
                  aria-label={`Guarda la promozione "${slide.seoName}"`}
                >
                  <ImageDispatcher
                    alt={`Immagine della promozione "${slide.seoName}"`}
                    src={slide.imgUrl}
                    className={index >= 1 ? 'lazyload' : ''}
                  />
                </Link>
              );
            } else {
              return (
                <ImageDispatcher
                  alt={`Immagine della promozione "${slide.seoName}"`}
                  src={slide.imgUrl}
                  className={index >= 1 ? 'lazyload' : ''}
                />
              );
            }
          })}
        </div>
      </div>
    );
  };

  return <>{renderModuleBannerCarousel()}</>;
};

export default ModuleBannerCarousel;
